import { defaultSchema } from "rehype-sanitize";
/**
 * Tags every Markdown surface may render.
 *
 * This is a security allowlist: anything absent here is stripped from user
 * authored content. Keep it as small as the rendered Markdown actually needs,
 * and never widen it to make a single screen work — extend the schema in the
 * owning app instead, with `createMarkdownSanitizeSchema`.
 */
const BASE_ALLOWED_TAGS = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "p",
    "br",
    "hr",
    "span",
    "div",
    "em",
    "strong",
    "del",
    "q",
    "ul",
    "ol",
    "li",
    "blockquote",
    "code",
    "pre",
];
const BASE_ATTRIBUTES = { ...defaultSchema.attributes };
export const baseMarkdownSanitizeSchema = {
    ...defaultSchema,
    tagNames: BASE_ALLOWED_TAGS,
    attributes: BASE_ATTRIBUTES,
};
export const createMarkdownSanitizeSchema = ({ tagNames = [], attributes = {}, }) => {
    const mergedAttributes = { ...BASE_ATTRIBUTES };
    for (const [tagName, tagAttributes] of Object.entries(attributes)) {
        // `?? []` covers a tag the base lists no attributes for, e.g. `aside`.
        mergedAttributes[tagName] = [...(BASE_ATTRIBUTES[tagName] ?? []), ...tagAttributes];
    }
    return {
        ...baseMarkdownSanitizeSchema,
        // De-duplicated: a caller re-declaring a base tag should not appear twice.
        tagNames: [...new Set([...BASE_ALLOWED_TAGS, ...tagNames])],
        attributes: mergedAttributes,
    };
};
